import { createContext, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";

const Ctx = createContext(null);

export function ShopperProvider({ children }) {
  const [member, setMember] = useState(null);
  const [site, setSite] = useState(null);
  const [country, setCountryState] = useState(localStorage.getItem("shopper_country") || "ID");

  useEffect(() => {
    http.get("/public/site").then((r) => {
      setSite(r.data);
      if (!localStorage.getItem("shopper_country")) setCountryState(r.data.default_country || "ID");
      if (!localStorage.getItem("ex_lang") && r.data.extranet_default_lang) localStorage.setItem("ex_lang", r.data.extranet_default_lang);
    });
    if (!localStorage.getItem("member_token")) return;
    http.get("/auth/me").then((r) => setMember(r.data)).catch(() => localStorage.removeItem("member_token"));
  }, []);

  const signIn = ({ token, member: m }) => { localStorage.setItem("member_token", token); setMember(m); };
  const signOut = () => { localStorage.removeItem("member_token"); setMember(null); };
  const setCountry = (c) => { localStorage.setItem("shopper_country", c); setCountryState(c); };

  return <Ctx.Provider value={{ member, signIn, signOut, country, setCountry, site }}>{children}</Ctx.Provider>;
}

export const useShopper = () => useContext(Ctx);
